import React, { useState } from "react";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

import GclickAiAgent from "./GclickAiAgent";
import GclickIframe from "./GclickIframe";

const useStyles = makeStyles(theme => ({
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2)
  },
  // Painel inativo sai com display:none pra não sobrepor o ativo; o
  // minHeight segura a altura do modal, espelhando o height da chatWindow
  // em GclickAiAgent (65vh) -- se aquele valor mudar, mude aqui também.
  panels: {
    display: "grid",
    minHeight: "65vh"
  },
  panel: {
    gridArea: "1 / 1",
    minWidth: 0
  },
  panelHidden: {
    display: "none"
  }
}));

// Conteúdo do modal do card G-Click em Platforms/index.js. As duas abas são
// integrações reais e independentes: o Agente de I.A. fala com a API da
// G-Click (OAuth, saindo daqui), e a aba Aplicativo configura o caminho
// contrário -- o token que a G-Click usa pra chamar a gente e a URL do
// painel que embutimos no atendimento.
const GclickModal = ({ status, onStatusChange, onClose, initialTab = 0 }) => {
  const classes = useStyles();

  // Aba inicial vem de quem abriu. Pelo card da página Plataformas é sempre 0
  // (Agente de I.A.): é a tela que já existia e a que o usuário abre no dia a
  // dia. Pela tabela, é a aba da linha que o usuário clicou -- a lixeira e o
  // lápis da linha "Aplicativo" têm que cair na aba Aplicativo.
  //
  // O índice vem da posição em PLATFORMS_CATALOG[].integrations (backend), ou
  // seja: a ordem daquela lista tem que seguir a ordem das <Tab> aqui.
  const [tab, setTab] = useState(initialTab);

  return (
    <div>
      <Tabs
        value={tab}
        onChange={(e, next) => setTab(next)}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        <Tab label={i18n.t("platforms.gclick.tabs.aiAgent")} />
        <Tab label={i18n.t("platforms.gclick.tabs.app")} />
      </Tabs>

      {/* Os dois painéis ficam montados de propósito -- trocar de aba não
          pode perder o que o usuário digitou no chat nem refazer os fetches
          de providers/config/mensagens do agente -- por isso display:none e
          não desmontar, que é o que o TabPanel do @material-ui/lab faria. */}
      <div className={classes.panels}>
        <div
          role="tabpanel"
          hidden={tab !== 0}
          className={`${classes.panel} ${tab !== 0 ? classes.panelHidden : ""}`}
        >
          <GclickAiAgent
            status={status}
            onStatusChange={onStatusChange}
            onClose={onClose}
            active={tab === 0}
          />
        </div>
        <div
          role="tabpanel"
          hidden={tab !== 1}
          className={`${classes.panel} ${tab !== 1 ? classes.panelHidden : ""}`}
        >
          <GclickIframe status={status} onStatusChange={onStatusChange} />
        </div>
      </div>
    </div>
  );
};

export default GclickModal;
